// How an order is meant to reach the customer, as Shopify's fulfillment order
// reports it. Null means ShipPromise could not read one — an order with no open
// fulfillment order left, or a backlog row hydrated from a snapshot taken
// before this field existed. That is unknown, not "no delivery method".

const NOT_SHIPPED_LABELS: Record<string, string> = {
  PICK_UP: "Local pickup",
  LOCAL: "Local delivery",
  RETAIL: "In-store sale",
};

// NONE is Shopify saying the fulfillment order has no delivery method at all,
// which happens on digital goods and on some imported orders. It is worth
// showing, but it does not mean the merchant is wrong to buy a label.
const SHIPPABLE = new Set(["SHIPPING", "NONE"]);

export interface DeliveryMethodBadge {
  label: string;
  // Polaris default (gray) for the merely-unusual, warning (yellow) for the
  // ones where buying a label would be a mistake.
  tone: "warning" | undefined;
}

export function deliveryMethodBadge(methodType: string | null): DeliveryMethodBadge | null {
  if (methodType === null || methodType === "SHIPPING") return null;
  if (methodType === "NONE") return { label: "No delivery method", tone: undefined };
  return { label: NOT_SHIPPED_LABELS[methodType] ?? methodType, tone: "warning" };
}

// An unrecognised method type is treated as not shippable: if Shopify adds
// another way of handing an order over in person, the safe failure is a button
// the merchant has to ask about, not a label they have already paid for.
export function isShippable(methodType: string | null): boolean {
  return methodType === null || SHIPPABLE.has(methodType);
}
